// One cloud-choice card (Flow 5; docs/phase-0/slice5-ux-flows.md §8.1;
// docs/phase-0/slice5-component-designs.md §3.5 `.cloud-choice-card`) - a selectable
// card reusing `TypePicker.tsx`'s own selectable-card interaction
// (`.type-card[aria-pressed]`, TypePicker.tsx:114-134) for a two-option choice instead
// of three. Neither card is visually implied as "recommended" unless a plain reason
// accompanies it (ux spec §8.1/§8.3) - never a silent pre-check with no explanation.
import { useId } from "react";

export const BuildCloudChoiceCard = ({
  title,
  description,
  selected,
  defaultReason,
  disabledReason,
  onSelect,
}: {
  readonly title: string;
  readonly description: string;
  readonly selected: boolean;
  /** States plainly why this option is pre-selected (e.g. a plan default) - never a
   * silent pre-check with no explanation (ux spec §8.3). */
  readonly defaultReason?: string;
  /** Present only for a viewer (role-gated); omitted entirely for an owner/admin. */
  readonly disabledReason?: string;
  readonly onSelect: () => void;
}): React.JSX.Element => {
  const reasonId = useId();
  const disabled = disabledReason !== undefined;

  return (
    <button
      type="button"
      className="card pad type-card cloud-choice-card"
      aria-pressed={selected}
      disabled={disabled}
      aria-describedby={disabled ? reasonId : undefined}
      onClick={onSelect}
    >
      <div className="row aic gap8">
        <span className="h3">{title}</span>
        {selected ? (
          <span className="check" aria-hidden="true">
            ✓
          </span>
        ) : null}
      </div>
      <p className="muted">{description}</p>
      {defaultReason !== undefined ? (
        <p className="muted" style={{ fontSize: 12 }}>
          {defaultReason}
        </p>
      ) : null}
      {disabled ? (
        <span className="sr-only" id={reasonId}>
          {disabledReason}
        </span>
      ) : null}
    </button>
  );
};
